import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

import Icon from '../../../components/AppIcon';

const ContractorForm = ({ formData, errors, onChange }) => {
  const skillOptions = [
    { value: 'electrical', label: 'Elektriciteit' },
    { value: 'hvac', label: 'HVAC Systemen' },
    { value: 'plumbing', label: 'Loodgieterij' },
    { value: 'solar', label: 'Zonnepanelen' },
    { value: 'heat_pump', label: 'Warmtepompen' },
    { value: 'airco', label: 'Airconditioning' },
    { value: 'ventilation', label: 'Ventilatie' },
    { value: 'smart_home', label: 'Smart Home Systemen' },
    { value: 'maintenance', label: 'Onderhoud' },
    { value: 'installation', label: 'Installatie' }
  ];

  const experienceLevelOptions = [
    { value: 'junior', label: 'Junior (0-2 jaar)' },
    { value: 'medior', label: 'Medior (2-5 jaar)' },
    { value: 'senior', label: 'Senior (5-10 jaar)' },
    { value: 'expert', label: 'Expert (10+ jaar)' }
  ];

  const availabilityOptions = [
    { value: 'full_time', label: 'Fulltime' },
    { value: 'part_time', label: 'Parttime' },
    { value: 'weekends', label: 'Weekenden' },
    { value: 'flexible', label: 'Flexibel' },
    { value: 'evenings', label: 'Avonden' }
  ];

  const serviceTypeOptions = [
    { value: 'residential', label: 'Woningbouw' },
    { value: 'commercial', label: 'Commercieel' },
    { value: 'industrial', label: 'Industrieel' },
    { value: 'maintenance', label: 'Onderhoud' },
    { value: 'emergency', label: 'Spoedopdrachten' }
  ];

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Wrench" size={20} />
          Vaardigheden en Expertise
        </h3>
        
        <Select
          label="Vaardigheden"
          options={skillOptions}
          value={formData?.skills || []}
          onChange={(value) => onChange('skills', value)}
          multiple
          searchable
          placeholder="Selecteer uw vaardigheden"
          description="Selecteer alle vaardigheden die u beheerst"
          error={errors?.skills}
          required
        />

        <Select
          label="Ervaringsniveau"
          options={experienceLevelOptions}
          value={formData?.experienceLevel}
          onChange={(value) => onChange('experienceLevel', value)}
          placeholder="Selecteer uw ervaringsniveau"
          error={errors?.experienceLevel}
          required
        />
      </div>

      <div className="border-t border-border pt-6 space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="FileText" size={20} />
          Certificeringen
        </h3>
        
        <Input
          label="Certificeringen"
          type="text"
          placeholder="Bijv. VCA, NEN3140, etc. (gescheiden door komma's)"
          value={formData?.certificationsText || ''}
          onChange={(e) => {
            const certs = e?.target?.value?.split(',')?.map(c => c?.trim())?.filter(Boolean);
            onChange('certifications', certs);
            onChange('certificationsText', e?.target?.value);
          }}
          description="Voer uw certificeringen in, gescheiden door komma's"
          error={errors?.certifications}
        />
      </div>

      <div className="border-t border-border pt-6 space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Calendar" size={20} />
          Beschikbaarheid en Tarieven
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Beschikbaarheid"
            options={availabilityOptions}
            value={formData?.availability || []}
            onChange={(value) => onChange('availability', value)}
            multiple
            placeholder="Selecteer uw beschikbaarheid"
            error={errors?.availability}
            required
          />

          <Input
            label="Uurtarief (€)"
            type="number"
            placeholder="45.00"
            value={formData?.hourlyRate || ''}
            onChange={(e) => onChange('hourlyRate', e?.target?.value)}
            description="Uw standaard uurtarief"
            error={errors?.hourlyRate}
          />

          <Input
            label="Reisafstand (km)"
            type="number"
            placeholder="50"
            value={formData?.travelDistance || ''}
            onChange={(e) => onChange('travelDistance', e?.target?.value)}
            description="Maximale reisafstand voor opdrachten"
            error={errors?.travelDistance}
          />

          <Select
            label="Type Diensten"
            options={serviceTypeOptions}
            value={formData?.serviceTypes || []}
            onChange={(value) => onChange('serviceTypes', value)}
            multiple
            placeholder="Selecteer type diensten"
            error={errors?.serviceTypes}
          />
        </div>
      </div>
    </div>
  );
};

export default ContractorForm;